/* Naar Halı: telefonda yatay kaydırılan ürün satırı için "kaydırılabilir" ipucu (22 Eki 2026)

   SORUN: Telefonda satır sağa kaydırılabiliyor ama müşteri bunu anlamıyordu (yalnızca ince bir ilerleme çizgisi vardı).
   ÇÖZÜM (üç ipucu birlikte):
     1) Satırın sağ kenarında, görselin ortasında "Kaydırın >" düğmesi. Dokununca satırı bir kart ilerletir.
        Müşteri kaydırmaya başlayınca (24 px'ten fazla) bir daha çıkmaz.
     2) Satır ekranda yarıdan fazla göründüğünde bir kez, içerik sağa doğru kısa bir "gösterip geri çekilir" hareketi
        yapar (kaydırma konumunu değiştirmez, yalnızca transform; dokunulursa kesilir).
     3) Temanın kendi ilerleme çizgisi ve sağda görünen sonraki kartın kenarı (zaten vardı).
   Hareketi azalt açıksa 2. ipucu oynamaz, düğme sabit durur.

   KAPSAM: Yalnızca sections/featured-collection.liquid içinde "Telefonda kaydırma ipucu göster" açık bölümlerde yüklenir
   (<div class="featured-collection" data-naar-ipucu>). Stil: assets/naar-duzeltmeler.css (.naar-ipucu).
   Sekmeli bölümde (Öne Çıkanlar) ikinci sekme sonradan eklendiği için tabChange olayı ve DOM gözlemi de dinlenir. */
(function () {
  'use strict';
  if (window.__naarKaydirIpucu) return;
  window.__naarKaydirIpucu = true;

  var dar = window.matchMedia('(max-width: 767.98px)');
  var azHareket = window.matchMedia('(prefers-reduced-motion: reduce)');
  var OK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function kur(satir) {
    if (satir.__naarIpucu) return;
    var panel = satir.closest('.tabs__panel') || satir.parentElement;
    var ic = satir.querySelector('.swipe-mobile__inner');
    if (!panel || !ic) return;
    satir.__naarIpucu = true;
    panel.classList.add('naar-ipucu-kok');

    var dugme = document.createElement('button');
    dugme.type = 'button';
    dugme.className = 'naar-ipucu naar-ipucu--gizli';
    dugme.setAttribute('aria-label', 'Sonraki ürünleri göster');
    dugme.innerHTML = '<span class="naar-ipucu__yazi">Kaydırın</span>' + OK;
    panel.appendChild(dugme);

    var bitti = false;

    // Düğme, ilk ürün görselinin dikey ortasında dursun (afiş kartı değil, ürün kartı)
    function yerlestir() {
      // İlk ürün kartının görseli: ürün bağlantısı içindeki ilk görsel (afiş kartı ürün bağlantısı taşımaz)
      var gorsel = null;
      var baglar = satir.querySelectorAll('a[href*="/products/"] img');
      for (var i = 0; i < baglar.length; i++) {
        if (baglar[i].getBoundingClientRect().height > 0) { gorsel = baglar[i]; break; }
      }
      if (!gorsel) return;
      var g = gorsel.getBoundingClientRect();
      var p = panel.getBoundingClientRect();
      // Görselin dikey ortasının biraz üstü: sağ alttaki sepete ekle düğmesini kapatmasın
      dugme.style.setProperty('--naar-ipucu-ust', Math.round(g.top - p.top + g.height * 0.42 - 20) + 'px');
    }

    function guncelle() {
      var tasma = satir.scrollWidth - satir.clientWidth;
      if (satir.scrollLeft > 24) bitti = true;
      var gizle = bitti || !dar.matches || tasma <= 8 || satir.clientWidth === 0;
      dugme.classList.toggle('naar-ipucu--gizli', gizle);
    }

    function salla() {
      if (azHareket.matches || bitti || !dar.matches) return;
      ic.classList.add('naar-ipucu-salla');
      var durdur = function () { ic.classList.remove('naar-ipucu-salla'); };
      ic.addEventListener('animationend', durdur, { once: true });
      satir.addEventListener('touchstart', durdur, { once: true, passive: true });
    }

    dugme.addEventListener('click', function () {
      var kart = ic.firstElementChild;
      var adim = kart ? kart.getBoundingClientRect().width + 12 : satir.clientWidth * 0.8;
      satir.scrollBy({ left: adim, behavior: 'smooth' });
    });
    satir.addEventListener('scroll', guncelle, { passive: true });
    window.addEventListener('resize', function () { yerlestir(); guncelle(); }, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { yerlestir(); guncelle(); }).observe(satir);
    }
    satir.querySelectorAll('img').forEach(function (i) {
      if (!i.complete) i.addEventListener('load', yerlestir, { once: true });
    });
    yerlestir();
    guncelle();

    if ('IntersectionObserver' in window) {
      var g = new IntersectionObserver(
        function (kayitlar) {
          if (kayitlar.some(function (k) { return k.isIntersecting && k.intersectionRatio >= 0.5; })) {
            g.disconnect();
            window.setTimeout(salla, 350);
          }
        },
        { threshold: [0.5] }
      );
      g.observe(satir);
    }
  }

  function tara() {
    document.querySelectorAll('[data-naar-ipucu] featured-collection.swipe-mobile').forEach(kur);
  }

  function baslat() {
    tara();
    // Sekme değişince ikinci panel şablondan eklenir
    document.addEventListener('tabChange', function () { window.setTimeout(tara, 60); });
    if ('MutationObserver' in window) {
      var bekliyor = false;
      var gozle = new MutationObserver(function () {
        if (bekliyor) return;
        bekliyor = true;
        window.requestAnimationFrame(function () { bekliyor = false; tara(); });
      });
      document.querySelectorAll('[data-naar-ipucu]').forEach(function (kok) {
        gozle.observe(kok, { childList: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
  document.addEventListener('shopify:section:load', tara);
})();
